module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1502.29cfd79f.jpg";